<template>
  <v-row>
    <v-col cols="12">
      <v-row>
        <v-col cols="12">
          <v-row
            justify="center"
            align="center"
            v-if="participants.length == 0"
          >
            <v-btn
              class="mx-2"
              fab
              large
              color="blue darken-1"
              @click="onAdd"
              :disabled="disabled"
              tabindex="-1"
            >
              <v-icon color="white">mdi-account-multiple</v-icon>
            </v-btn>
          </v-row>
          <v-list v-else two-line subheader>
            <template v-for="(item, index) in participants">
              <div :key="item.name + index">
                <v-subheader inset v-if="index == 0">Leader</v-subheader>
                <v-subheader inset v-if="index == 1">Others</v-subheader>
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon class="blue white--text">mdi-account</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title
                      >{{ item.title }} {{ item.name }}
                      {{ item.surname }}</v-list-item-title
                    >
                    <v-list-item-subtitle>{{
                      item.email
                    }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-container py-0>
                      <v-row>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              color="green"
                              icon
                              small
                              @click="onReplace(item)"
                              v-on="on"
                            >
                              <v-icon>mdi-account-convert</v-icon>
                            </v-btn>
                          </template>
                          Replace
                        </v-tooltip>
                        <v-tooltip bottom v-if="!hideEditClient">
                          <template v-slot:activator="{ on }">
                            <v-btn
                              color="primary"
                              icon
                              small
                              @click="onEdit(item)"
                              :disabled="!isEditableClient(item)"
                              v-on="on"
                            >
                              <v-icon>mdi-account-edit</v-icon>
                            </v-btn>
                          </template>
                          Edit
                        </v-tooltip>
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              color="error"
                              icon
                              small
                              @click="onRemove(item)"
                              v-on="on"
                            >
                              <v-icon>mdi-account-remove</v-icon>
                            </v-btn>
                          </template>
                          Remove
                        </v-tooltip>
                      </v-row>
                    </v-container>
                  </v-list-item-action>
                </v-list-item>
                <v-divider inset></v-divider>
              </div>
            </template>
          </v-list>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-btn
          color="primary"
          text
          @click="onAdd"
          id="addPaxBtn"
          :disabled="disabled"
          :loading="loading"
        >
          <v-icon v-if="participants.length > 0">mdi-plus-circle</v-icon>Add Pax
        </v-btn>
      </v-row>
      <add-pax-dialog
        :show="showAddPaxDialog"
        @close="showAddPaxDialog = false"
        @add="onAddPax"
      ></add-pax-dialog>
    </v-col>
  </v-row>
</template>

<script>
import AddPaxDialog from "./ItineraryBuilderAddPaxDialog";
import EventBus from "../../../../store/event-bus";
export default {
  name: "participants-list",
  props: {
    participants: {
      type: Array,
      default: () => [],
    },
    hideEditClient: {
      type: Boolean,
      default: () => false,
    },
    disabled: {
      type: Boolean,
      default: () => false,
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  components: {
    AddPaxDialog,
  },
  data() {
    return {
      debug: false,
      showAddPaxDialog: false,
      replaceIndex: -1,
    };
  },
  methods: {
    onAdd() {
      this.replaceIndex = -1;
      this.showAddPaxDialog = true;
    },
    onAddPax(payload) {
      if (this.replaceIndex > -1) {
        this.$emit("replace", { index: this.replaceIndex, new: payload });
      } else {
        this.$emit("add", payload);
      }
    },
    onRemove(item) {
      this.$emit("remove", this.participants.indexOf(item));
    },
    onEdit(item) {
      this.$emit("edit", { ...item });
    },
    isEditableClient(item) {
      return (item.client && item.client.id) || item.id ? true : false;
    },
    onReplace(item) {
      this.replaceIndex = this.participants.indexOf(item);
      this.showAddPaxDialog = true;
    },
  },
  mounted() {
    EventBus.$on("showAddPaxDialog", () => {
      this.showAddPaxDialog = true;
      this.replaceIndex = -1;
    });
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/itineraries/builder/ItineraryBuilderParticipantsList2.vue